import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FeedbackService } from '../../../core/services/feedback.service';
import { TeamContextService } from '../../../core/services/team-context.service';
import { FeedbackType, FeedbackPriority, FeedbackRequest } from '../../../core/models/feedback.model';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-feedback-button',
  templateUrl: './feedback-button.component.html',
  styleUrls: ['./feedback-button.component.scss']
})
export class FeedbackButtonComponent {
  isModalVisible = false;
  feedbackForm: FormGroup;
  submitting = false;

  feedbackTypes = [
    { label: 'Bug', value: FeedbackType.BUG, icon: 'bug' },
    { label: 'Solicitud de función', value: FeedbackType.FEATURE_REQUEST, icon: 'bulb' },
    { label: 'Mejora', value: FeedbackType.IMPROVEMENT, icon: 'rocket' },
    { label: 'Otro', value: FeedbackType.OTHER, icon: 'question-circle' }
  ];

  priorities = [
    { label: 'Baja', value: FeedbackPriority.LOW },
    { label: 'Media', value: FeedbackPriority.MEDIUM },
    { label: 'Alta', value: FeedbackPriority.HIGH },
    { label: 'Crítica', value: FeedbackPriority.CRITICAL }
  ];

  constructor(
    private fb: FormBuilder,
    private feedbackService: FeedbackService,
    private teamContext: TeamContextService,
    private message: NzMessageService
  ) {
    this.feedbackForm = this.fb.group({
      type: [FeedbackType.BUG, Validators.required],
      title: ['', [Validators.required, Validators.maxLength(255)]],
      description: ['', [Validators.required, Validators.maxLength(5000)]],
      priority: [FeedbackPriority.MEDIUM]
    });
  }

  showModal(): void {
    this.isModalVisible = true;
  }

  handleCancel(): void {
    this.isModalVisible = false;
    this.feedbackForm.reset({
      type: FeedbackType.BUG,
      priority: FeedbackPriority.MEDIUM
    });
  }

  handleSubmit(): void {
    if (this.feedbackForm.valid) {
      this.submitting = true;

      const feedbackRequest: FeedbackRequest = {
        ...this.feedbackForm.value,
        url: window.location.href,
        userAgent: navigator.userAgent,
        browserInfo: this.getBrowserInfo()
      };

      // Add team ID if available
      const selectedTeam = this.teamContext.getSelectedTeam();
      if (selectedTeam) {
        feedbackRequest.teamId = selectedTeam.id;
      }

      this.feedbackService.createFeedback(feedbackRequest).subscribe({
        next: () => {
          this.message.success('¡Gracias por tu feedback! Lo revisaremos pronto.');
          this.handleCancel();
          this.submitting = false;
        },
        error: (error) => {
          console.error('Error submitting feedback:', error);
          this.message.error('Error al enviar el feedback. Por favor, inténtalo de nuevo.');
          this.submitting = false;
        }
      });
    } else {
      Object.values(this.feedbackForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  private getBrowserInfo(): string {
    return JSON.stringify({
      platform: navigator.platform,
      language: navigator.language,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      cookieEnabled: navigator.cookieEnabled,
      onLine: navigator.onLine
    });
  }
}
